/**
 * @prettier
 */
import * as React from 'react';
import { Button } from 'src/components/Button';
import { translate } from 'src/i18n/translate';
import { usePrintOrderCommand } from 'src/services/printer/usePrintOrderCommand';
import type { OrderVm } from 'src/types/OrderVm';

export function PrintOrderCommandButton({ order, disabled }: Props): React.ReactElement {
    const [printOrderCommand] = usePrintOrderCommand();

    const handlePrintCommand = async () => {
        await printOrderCommand(order, true);
    };

    return (
        <Button secondary onClick={handlePrintCommand} disabled={disabled}>
            {translate('Print Command')}
        </Button>
    );
}

type Props = {
    order: OrderVm;
    disabled?: boolean;
};
